import React from "react";
import { WSPage } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router";
import { OpenPayableAgingReportDashboard } from "./OpenPayableAgingReportDashboard";
import { WSQueries } from "../../../../query/WSQuery";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";
import { queriesCustomFields } from "@query";

export const RouteOpenPayableAgingReport: React.FC = () => {
  const history = useHistory();

  const queryCustomFieldsAll =
    queriesCustomFields.listCustomFields.useQueryAll();
  const customFields = (queryCustomFieldsAll.flatData ?? []).filter(
    customField => customField.resourceType === CustomFieldResourceType.PAYEE
  );

  return (
    <WSPage
      title="Open Payable Aging"
      breadcrumb={{
        label: "Back",
        onClick() {
          history.push("/member/reports");
        },
        icon: "arrow-left"
      }}
    >
      <WSQueries queries={{ customFields: queryCustomFieldsAll }}>
        {() => (
          <OpenPayableAgingReportDashboard customFieldsData={customFields} />
        )}
      </WSQueries>
    </WSPage>
  );
};
